// assets
import { AiOutlineSetting, AiOutlineLogout } from 'react-icons/ai';

const generalPages = {
  id: 'account',
  title: 'Account',
  type: 'group',
  children: [
    {
      id: 'settings',
      title: 'Settings',
      type: 'item',
      url: '/dashboard/settings',
      icon: AiOutlineSetting
    },
    {
      id: 'logout',
      title: 'Logout',
      type: 'item',
      url: '/logout',
      icon: AiOutlineLogout
    }
  ]
};

export default generalPages;
